import { AttributesSelector, Box, Select } from '@workwhile/ui'
import React, { useMemo } from 'react'
import type { HubSelectOption } from '../context/i9HubSelectOptions'

type HubUrlSelectFilterProps = {
  label: string
  filterKey: string
  options: HubSelectOption[]
  value: string | null
  onChange: (value: string | null) => void
  placeholder?: string
  isClearable?: boolean
}

export function HubUrlSelectFilter({
  label,
  filterKey,
  options,
  value,
  onChange,
  placeholder,
  isClearable = true,
}: HubUrlSelectFilterProps) {
  const selectedAttributes = useMemo(() => {
    if (!value) return []
    const option = options.find((candidate) => candidate.value === value)
    return option ? [option.label] : [value]
  }, [value, options])

  return (
    <AttributesSelector
      label={label}
      rootGroupTitle="Filter by"
      selectedAttributes={selectedAttributes}
      onClearAll={() => onChange(null)}
      groups={
        <AttributesSelector.Group
          key={filterKey}
          title={label}
          numberOfSelectedAttributes={selectedAttributes.length}
        >
          <Box>
            <Select
              options={options}
              placeholder={placeholder ?? `Select ${label.toLowerCase()}...`}
              isClearable={isClearable}
              value={
                options.find((candidate) => candidate.value === value) ?? null
              }
              onChange={(option) => onChange(option ? option.value : null)}
            />
          </Box>
        </AttributesSelector.Group>
      }
    />
  )
}
